<div class="container-default">
  <common-simple-search class="d-lg-none"></common-simple-search>
  <common-top-bar-navigation [navigationItems]="routesService.allNavigationItems"></common-top-bar-navigation>

  <div class="container pt-2 pt-lg-4">
    <router-outlet></router-outlet>
  </div>
</div>
<common-footer></common-footer>
